// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-loading[data-v-4587dcc1]{align-items:center;display:flex;height:100%;justify-content:center;padding:32px;text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
